import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './SplashScreen.css';

function SplashScreen({ onComplete }) {
  const [phase, setPhase] = useState('white'); // 'white', 'ray', 'logo', 'tagline'

  useEffect(() => {
    // Phase timing: white -> ray of light -> pause -> logo -> tagline
    const rayTimer = setTimeout(() => setPhase('ray'), 500);
    const logoTimer = setTimeout(() => setPhase('logo'), 2000);
    const taglineTimer = setTimeout(() => setPhase('tagline'), 3000);
    const completeTimer = setTimeout(() => onComplete(), 5000);

    return () => {
      clearTimeout(rayTimer);
      clearTimeout(logoTimer);
      clearTimeout(taglineTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div className={`splash-screen ${phase}`}>
      {/* Golden light that expands from center to fill screen */}
      <motion.div
        className="golden-light"
        initial={{ scale: 0, opacity: 0 }}
        animate={{
          scale: phase === 'white' ? 0 : 3,
          opacity: phase === 'white' ? 0 : 1
        }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      />

      {/* Logo - tree + ELLai text */}
      <motion.div
        className="splash-logo-container"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{
          opacity: phase === 'logo' || phase === 'tagline' ? 1 : 0,
          scale: phase === 'logo' || phase === 'tagline' ? 1 : 0.9
        }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        {/* Tree icon */}
        <img
          src="/ellai-tree.png?v=4"
          alt="ELLai Tree"
          className="splash-tree"
        />
        {/* ELLai branded text */}
        <h1 className="splash-brand-text">
          <span className="splash-ell">ELL</span>
          <span className="splash-ai">ai</span>
        </h1>
      </motion.div>

      {/* Tagline with separator */}
      <motion.div
        className="splash-tagline-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{
          opacity: phase === 'tagline' ? 1 : 0,
          y: phase === 'tagline' ? 0 : 20
        }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <div className="splash-separator" />
        <p className="splash-tagline">Eternal Living Legacy</p>
      </motion.div>

      {/* Skip button */}
      <motion.button
        className="splash-skip"
        onClick={onComplete}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2, duration: 0.5 }}
      >
        Skip
      </motion.button>
    </div>
  );
}

export default SplashScreen;
